angular.module('app.general').filter('scCountWithFallback', scCountWithFallback);

function scCountWithFallback() {
  return function (input) {
    return input != null ? `(${input})` : '';
  };
}
